var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uvForm',{ref:"uForm",attrs:{"model":_vm.model,"rules":_vm.rules,"errorType":_vm.errorType,"borderBottom":_vm.borderBottom,"labelPosition":_vm.labelPosition,"labelWidth":_vm.labelWidth,"labelAlign":_vm.labelAlign,"labelStyle":_vm.labelStyle,"customStyle":_vm.customStyle}},[_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }